module.exports = __webpack_public_path__ + "media/sasong_oliv.ce7ad7b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/landing/sasong_oliv.png
// module id = 607
// module chunks = 0